import { render, staticRenderFns } from "./ExportShortcut.vue?vue&type=template&id=3ef06a8b"
import script from "./ExportShortcut.vue?vue&type=script&lang=js"
export * from "./ExportShortcut.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports